export default __webpack_public_path__ + "static/media/florist1.1a5bed1a.jpg";